import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const featuresData = [
    {
        'icon': iconOne,
        'title': 'Patient Safety First',
        'description': 'We follow strict sterilisation protocols and use modern, safe equipment for every procedure at Veloura Dental.'
    },
    {
        'icon': iconTwo,
        'title': 'Affordable Care',
        'description': 'Quality dental and homoeopathic care should be accessible to all. We offer transparent pricing and flexible payment options.'
    },
    {
        'icon': iconThree,
        'title': 'Full-Service Clinic',
        'description': 'From check-ups to root canals, teeth whitening, cosmetic dentistry, and homoeopathic treatments — all under one roof.'
    },
    {
        'icon': iconFour,
        'title': 'All Ages Welcome',
        'description': 'We provide gentle, compassionate care for patients of all ages — from children to seniors — at Nikol, Ahmedabad.'
    }
]

export default featuresData;
